import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocAiCaseSearchFlat(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M92.278 100.015c6.294 0 11.395-5.102 11.395-11.395H46.699c0 6.293-5.102 11.395-11.395 11.395h56.974Z"
        fill="#E2E8F0"
      />
      <path
        d="M35.304 100.015c-6.293 0-11.395-5.102-11.395-11.395V20.25h56.975v68.37c0 6.293 5.101 11.395 11.395 11.395H35.304Z"
        fill="#F1F5F9"
      />
      <path
        d="M80.084 88.62c0 6.735 5.46 12.194 12.194 12.194a.8.8 0 1 0 0-1.6c-5.851 0-10.594-4.743-10.595-10.594a.8.8 0 1 0-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M42.805 36.722c.29 0 .57.121.764.345l.006.006.007.006.005.006c.193.23.276.528.224.826L41.93 48.713v.005c-.106.522-.585.794-.979.795l-4.92.009c-.118 0-.236-.02-.296-.04a.966.966 0 0 1-.604-.47l-.002-.002-2.374-4.468a1 1 0 0 1 .022-.998 1.02 1.02 0 0 1 .87-.493l2.291-.004.95-5.474c.088-.482.503-.841.997-.842l4.92-.009Zm-5.8 7.587-.69 3.955 4.21-.008-2.1-3.95-1.42.003Zm-2.95-.001 1.256 2.364.412-2.367-1.668.003Zm4.045-6.314-.876 5.057 1.35-.003c.327 0 .63.16.82.418l.073.115.002.002 1.566 2.947 1.486-8.544-4.421.008Z"
        fill="#78B441"
      />
      <path
        d="M32.455 78.323a.801.801 0 0 0 0 1.601h39.882a.8.8 0 0 0 0-1.6H32.455Zm0-5.697a.8.8 0 0 0 0 1.6h39.882a.8.8 0 0 0 0-1.6H32.455Zm0-5.697a.8.8 0 1 0 0 1.6h39.882a.8.8 0 1 0 0-1.6H32.455Zm0-5.697a.8.8 0 1 0 0 1.6h39.882a.8.8 0 1 0 0-1.6H32.455Zm0-5.697a.8.8 0 1 0 0 1.6h39.882a.8.8 0 0 0 0-1.6H32.455Zm17.092-5.699a.8.8 0 0 0 0 1.6h22.79a.8.8 0 0 0 0-1.6h-22.79Zm0-5.697a.8.8 0 0 0 0 1.6h22.79a.8.8 0 0 0 0-1.6h-22.79Zm0-5.697a.8.8 0 0 0 0 1.6h22.79a.8.8 0 1 0 0-1.6h-22.79Zm0-5.698a.8.8 0 0 0 0 1.6h22.79a.8.8 0 1 0 0-1.6h-22.79Z"
        fill="#B3C0D0"
      />
      <path
        d="m91.074 53.179 18.462 15.392a4.072 4.072 0 1 1-5.457 6.037L86.907 57.789l4.167-4.61Z"
        fill="#007A5F"
      />
      <path d="m96.877 58.017.547 10.074-10.517-10.302 4.167-4.61 5.803 4.837Z" fill="#00664F" />
      <path
        d="m96.876 58.017.548 10.074-10.517-10.302 4.168-4.61 5.801 4.837Zm-7.753-.295 6.48 6.344-.287-5.268-4.086-3.407-2.107 2.33Z"
        fill="#00664F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.02 62.739c8.334 4.266 18.548.97 22.815-7.364 4.266-8.333.97-18.547-7.364-22.813-8.333-4.267-18.547-.97-22.814 7.363-4.266 8.334-.97 18.547 7.364 22.814Z"
        fill="#78B441"
      />
      <path
        d="M93.173 47.93c0 6.709-5.439 12.148-12.148 12.148-6.71 0-12.149-5.44-12.149-12.149 0-6.71 5.44-12.148 12.149-12.148 6.71 0 12.148 5.439 12.148 12.148Z"
        fill="#CAE8DF"
      />
      <path
        d="M70.902 47.93c0-5.592 4.532-10.124 10.123-10.124a.8.8 0 1 1 0 1.6 8.524 8.524 0 0 0-8.523 8.523.8.8 0 1 1-1.6 0Z"
        fill="#fff"
      />
      <path
        d="M68.076 47.93c0-7.152 5.798-12.949 12.949-12.949a.8.8 0 1 1 0 1.6c-6.268 0-11.349 5.08-11.349 11.348 0 6.268 5.081 11.349 11.349 11.349a.8.8 0 1 1 0 1.6c-7.151 0-12.949-5.797-12.949-12.949Z"
        fill="#0F172A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m23.68 76.517-.652-2.038a1.562 1.562 0 0 0-.985-1.005l-1.998-.667c-.474-.155-.474-.84 0-1.005l1.998-.667c.464-.154.833-.531.985-1.005l.653-2.039c.151-.483.824-.483.985 0l.653 2.04c.152.473.52.85.985 1.004l1.998.667c.473.154.473.84 0 1.005l-1.998.667a1.562 1.562 0 0 0-.985 1.005l-.653 2.038c-.152.484-.824.484-.985 0Zm-7.442 15.22-1.23-3.846c-.294-.899-.976-1.604-1.856-1.894L9.383 84.74c-.89-.3-.89-1.585 0-1.885l3.769-1.256c.88-.3 1.572-.995 1.856-1.894l1.23-3.846a.966.966 0 0 1 1.847 0l1.23 3.846c.294.899.976 1.604 1.857 1.894l3.768 1.256c.89.3.89 1.585 0 1.885l-3.768 1.256c-.88.3-1.572.995-1.856 1.894l-1.231 3.846a.966.966 0 0 1-1.847 0Z"
        fill="#007A5F"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocAiCaseSearchFlat)
